import React from 'react'

/*
 * Components
 * Import Text from 'ui/Text'
 */
import Container from 'ui/Container'
import Header from 'ui/Header'
import Navbar from 'ui/Navbar'
import Breadcrumb from 'ui/Breadcrumb'
import Footer from 'ui/Footer'
import TicketsClosed from 'components/Ticketing/TicketsClosed'

// Paths
import { PATH_TICKET_SUPPORT } from 'routes/paths'

export default function PageTicketsArchived() {
  const breadcrumbs = [
    {
      label: 'Help & support',
      path: PATH_TICKET_SUPPORT,
    },
    {
      label: 'Archive',
    },
  ]

  return (
    <>
      <Header />
      <Navbar />
      <Container>
        <Breadcrumb items={breadcrumbs} />
        <TicketsClosed />
      </Container>
      <Footer />
    </>
  )
}
